
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { MapPin, Users } from 'lucide-react';
import { DestinationImage } from './card/DestinationImage';
import { FormattedDestination } from './types/destination';
import { MobileOptimizedImage } from '@/components/shared/MobileOptimizedImage';
import { isMobileDevice } from '@/lib/lcp-optimization';

interface DestinationCardProps {
  destination: FormattedDestination;
  isFollowed?: boolean;
  onToggleFollow?: () => void;
  onClick?: () => void;
  isLcp?: boolean;
}

const DestinationCard: React.FC<DestinationCardProps> = ({
  destination,
  isFollowed = false,
  onToggleFollow = () => {},
  onClick,
  isLcp = false
}) => {
  const isMobile = isMobileDevice();
  
  return (
    <Card 
      className="cursor-pointer hover:shadow-md transition-shadow duration-200 overflow-hidden"
      onClick={onClick}
    >
      <div className="aspect-[4/3] overflow-hidden">
        {isMobile ? (
          <MobileOptimizedImage
            src={destination.image_url || ''}
            alt={destination.name}
            width={400}
            height={300}
            className="w-full h-full object-cover"
            isLcp={isLcp}
            aspectRatio="auto"
          />
        ) : (
          <DestinationImage
            imageUrl={destination.image_url}
            name={destination.name}
            isFollowed={isFollowed}
            hasBeach={destination.has_beach}
            onToggleFollow={(e) => {
              e.stopPropagation();
              onToggleFollow();
            }}
            isLcp={isLcp}
          />
        )}
      </div>
      
      <CardContent className="p-4">
        <div className="space-y-2">
          <h3 className="font-semibold text-lg line-clamp-1">{destination.name}</h3>
          
          <div className="flex items-center text-sm text-muted-foreground">
            <MapPin className="w-4 h-4 mr-1 flex-shrink-0" />
            <span className="line-clamp-1">{destination.country}</span>
          </div>
          
          {destination.description && (
            <p className="text-sm text-muted-foreground line-clamp-2">
              {destination.description}
            </p>
          )}
          
          {destination.hosts && destination.hosts.length > 0 && (
            <div className="flex items-center text-sm text-muted-foreground pt-2">
              <Users className="w-4 h-4 mr-1 flex-shrink-0" />
              <span>{destination.hosts.length} local host{destination.hosts.length !== 1 ? 's' : ''}</span>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default DestinationCard;
